import React from 'react';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { useTranslation } from 'react-i18next';
import { Box, SvgIconProps, fade } from '@material-ui/core';
import styled from 'styled-components';
import { CalendarMonthIcon, Typography } from '../../../../ui-kit';

interface DateWithtTitleProps {
    title: string;
    subtitle: string;
    Icon?: React.ComponentType<SvgIconProps>;
    style?: React.CSSProperties;
    className?: string;
}

const Circle = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    ${({ theme }) => `
        background-color: ${fade(theme.palette.primary.main, 0.16)};
        color: ${theme.palette.primary.main};
        width: ${theme.spacing(3)}px;
        height: ${theme.spacing(3)}px;
    `}
`;

const Container = styled.div`
    display: grid;
    grid-template-columns: repeat(3, max-content);
    grid-template-areas: "start . end" "start arrow end";
    align-items: center;
    width: max-content;
    ${({ theme }) => `
        grid-template-rows: auto ${theme.spacing(3)}px;
        grid-gap: ${theme.spacing(2)}px;
        background-color: ${fade(theme.palette.primary.main, 0.16)};
        padding: ${theme.spacing(2)}px ${theme.spacing(2.5)}px;
        border-radius: ${theme.shape.borderRadius}px;
    `}
`;

// eslint-disable-next-line @typescript-eslint/naming-convention
const DateWithTitle = ({ title, subtitle, Icon = CalendarMonthIcon, ...rest }: DateWithtTitleProps) => {
    return (
        <div {...rest}>
            <Typography style={{ marginLeft: 5 }} variant='overline' color='primary'>{title}</Typography>
            <Box display='grid' gridGap={4} gridAutoFlow='column' gridAutoColumns='max-content'>
                <Circle>
                    <Icon fontSize='small' />
                </Circle>
                <Typography variant='subtitle1'>{subtitle}</Typography>
            </Box>
        </div>
    );
};

interface StartEndCardProps {
    startDateText: string;
    endDateText: string;
}

const StartEndCard = ({ startDateText, endDateText }: StartEndCardProps) => {
    const { t } = useTranslation();

    return (
        <Container>
            <DateWithTitle style={{ gridArea: 'start' }} title={t('Start date')} subtitle={startDateText} />
            <ArrowForwardIcon fontSize='inherit' style={{ gridArea: 'arrow', fontSize: 16 }} />
            <DateWithTitle style={{ gridArea: 'end' }} title={t('End date')} subtitle={endDateText} />
        </Container>
    );
};

export default StartEndCard;